module.exports = __webpack_public_path__ + "static/media/mobile.96d3339f.svg";